<cms-hotspots-wrapper class="w-12 pos-relative"
                      [component]="component"
                      [targetUrl]="component.cta_link">
    <div class="image-component overflow-hidden"
         [ngClass]="[component.ratio || '']">
        <local-shell />
        <img class="rf"
             [image]="component.image">
    </div>
</cms-hotspots-wrapper>
